import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import SectionHeader from './ui/SectionHeader';

const STEP_KEYS = ['understand', 'prototype', 'validate', 'build', 'iterate'] as const;

export default function HowIWork() {
  const { t } = useTranslation();

  return (
    <section
      id="how-i-work"
      className="section-padding section-surface"
      role="region"
      aria-labelledby="how-i-work-title"
    >
      <div className="container mx-auto max-w-6xl px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <SectionHeader
            id="how-i-work-title"
            title={t('home.howIWork.title')}
            description={t('home.howIWork.intro')}
          />

          <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 list-none p-0 relative">
            {/* Connector line on desktop */}
            <div
              className="hidden lg:block absolute top-8 left-[10%] right-[10%] h-px bg-linear-to-r from-transparent via-gray-200 dark:via-gray-700 to-transparent"
              aria-hidden="true"
            />
            {STEP_KEYS.map((key, index) => (
              <li key={key} className="h-full relative">
                <motion.div
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.08 }}
                  className="h-full p-5 glass-card-hover"
                >
                  <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 text-sm font-bold mb-3 ring-1 ring-blue-200/40 dark:ring-blue-700/30">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="block text-base font-medium text-gray-900 dark:text-white leading-snug">
                    {t(`home.howIWork.steps.${key}`)}
                  </span>
                </motion.div>
              </li>
            ))}
          </ol>
        </motion.div>
      </div>
    </section>
  );
}
